import type { RouteRecordRaw } from 'vue-router'
import { Layout } from '@/utils/routerHelper'

const logsRoutes: RouteRecordRaw[] = [
  {
    path: '/logs',
    name: 'Logs',
    component: Layout,
    meta: {
      title: '系统日志',
      icon: 'vi-ep:notebook',
      alwaysShow: true
    },
    children: [
      {
        path: 'login',
        component: () => import('@/views/Logs/LoginLogList.vue'),
        name: 'LoginLogList',
        meta: { title: '登录日志' }
      },
      {
        path: 'operation',
        component: () => import('@/views/Logs/OperationLogList.vue'),
        name: 'OperationLogList',
        meta: { title: '操作日志' }
      }
    ]
  }
]

export default logsRoutes
